export default "__VITE_ASSET__Bo3h65y5__"